// const API_BASE_URL = "https://staging-chatbot.amaphil.com.ph/api/v1";
// const BASE_URL = "https://staging-chatbot.amaphil.com.ph/api/v1";
// // const WEBSOCKET_HOST = "staging-chatbot.amaphil.com.ph/socket.io";
// const ACCREDITED_PROVIDERS = "https://allaccess.net.ph/ajax/test/accredited-providers/";
// // const BASE_AUTH_URL = "https://staging-chatbot.amaphil.com.ph/api/v1/x1bf/x1wh/auth-checker";
// const APP_BASE_URL = "https://staging-fb-chatbot.amaphil.com.ph";

// export { API_BASE_URL, ACCREDITED_PROVIDERS, APP_BASE_URL, BASE_URL };


// const BASE_URL = "https://staging-chatbot.amaphil.com.ph/api/v1";
// const WEBSOCKET_HOST = "staging-chatbot.amaphil.com.ph/socket.io";
// const ACCREDITED_PROVIDERS = "https://allaccess.net.ph/ajax/test/accredited-providers/";

// export { BASE_URL, WEBSOCKET_HOST, ACCREDITED_PROVIDERS };
const getConfig = () => {
    const hostname = window.location.hostname;
  
    if (hostname === 'fb-chatbot.amaphil.com.ph') {
      return {
        API_BASE_URL: 'https://chatbot.amaphil.com.ph/api/v1',
        BASE_URL: 'https://chatbot.amaphil.com.ph/api/v1',
        ACCREDITED_PROVIDERS: 'https://allaccess.net.ph/ajax/test/accredited-providers/',
        APP_BASE_URL: 'https://fb-chatbot.amaphil.com.ph',
        feedbackCheckMethod: 'api', // Options: 'localStorage' or 'api'
      };
    } else if (hostname === 'staging-fb-chatbot.amaphil.com.ph') {
        return {
            API_BASE_URL: 'https://staging-chatbot.amaphil.com.ph/api/v1',
            BASE_URL: 'https://staging-chatbot.amaphil.com.ph/api/v1',
            ACCREDITED_PROVIDERS: 'https://allaccess.net.ph/ajax/test/accredited-providers/',
            APP_BASE_URL: 'https://staging-fb-chatbot.amaphil.com.ph',
            feedbackCheckMethod: 'api', // Options: 'localStorage' or 'api'
          };
    } else {
      // Default configuration (e.g., for local development)
      // Uses production unless overridden in .env.local, e.g. to run against a local backend:
      //   REACT_APP_API_BASE_URL=http://localhost:8000/api/v1
      //   REACT_APP_APP_BASE_URL=http://localhost:3011
      const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || 'https://chatbot.amaphil.com.ph/api/v1';
      return {
        API_BASE_URL: apiBaseUrl,
        BASE_URL: apiBaseUrl,
        ACCREDITED_PROVIDERS: 'https://allaccess.net.ph/ajax/test/accredited-providers/',
        APP_BASE_URL: process.env.REACT_APP_APP_BASE_URL || 'https://fb-chatbot.amaphil.com.ph',
        feedbackCheckMethod: 'api', // Options: 'localStorage' or 'api'
      };
    }
  };
  
  const { API_BASE_URL, BASE_URL, ACCREDITED_PROVIDERS, APP_BASE_URL, feedbackCheckMethod  } = getConfig();
  
  export { API_BASE_URL, ACCREDITED_PROVIDERS, APP_BASE_URL, BASE_URL, feedbackCheckMethod };
  